import Vue from 'vue'
import Vuex from 'vuex'

let modules = {}
const requireModules = require.context('./modules', false, /\.(vue|js)$/)
requireModules.keys().forEach(fileName => {
  let moduleName = fileName.replace('./', '')
  moduleName = moduleName.replace('.js', '')
  modules[moduleName] = requireModules(fileName).default
})

Vue.use(Vuex)

export default new Vuex.Store({
  modules: modules,
  state: {
    navbar: true,
    load: false,
    problem: { show: false, id: null },
    ticket: { show: false, id: null },
    // question: {show: false,id: null},
    admin: { show: false, id: null },
    order: { show: false, id: null }
  },
  getters: {
    getNavbar (state) {
      return state.navbar
    },
    getLoad: state => {
      return state.load
    },
    getProblem: state => {
      return state.problem
    },
    getTicket: state => {
      return state.ticket
    },
    // getQuestion: state => {return state.question},
    getAdmin: state => {
      return state.admin
    },
    getOrder: state => {
      return state.order
    }
  },
  mutations: {
    showNavbar (state) {
      state.navbar = !state.navbar
    },
    loadStart: (state) => {
      state.load = true
    },
    loadDone: (state) => {
      state.load = false
    },
    addProblem: (state) => {
      state.problem = { show: true, id: null }
    },
    updateProblem: (state, id) => {
      state.problem = { show: true, id: id }
    },
    returnProblems: (state) => {
      state.problem = { show: false, id: null }
    },
    updateTicket: (state, id) => {
      state.ticket = { show: true, id: id }
    },
    returnTickets: (state) => {
      state.ticket = { show: false, id: null }
    },
    // addQuestion:      (state)     =>  {state.question = {show: true,  id: null}},
    // updateQuestion:   (state, id) =>  {state.question = {show: true,  id: id}},
    // returnQuestions:  (state)     =>  {state.question = {show: false, id: null}},
    addAdmin: (state) => {
      state.admin = { show: true, id: null }
    },
    updateAdmin: (state, id) => {
      state.admin = { show: true, id: id }
    },
    returnAdmins: (state) => {
      state.admin = { show: false, id: null }
    },
    addOrder: (state) => {
      state.order = { show: true, id: null }
    },
    updateOrder: (state, id) => {
      state.order = { show: true, id: id }
    },
    returnOrders: (state) => {
      state.order = { show: false, id: null }
    }
  },
  actions: {
    loadStart ({ commit }) {
      commit('loadStart')
    },
    loadDone ({ commit }) {
      setTimeout(() => {
        commit('loadDone')
      }, 500)
    }
  }
})
